import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { UserCheckIcon, UserIcon } from '@yonderland/andes-icons';
import { Icon, IconButton, IconLink, Link, LinkButton, useIsClient } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { NewAuthenticationContainer } from '../../containers/NewAuthenticationContainer';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
import { useOAuth } from '../../hooks/useOAuth';
import sessionActions from '../../redux/session/actions/SessionActions.creators';
import { NewAccountMenuPopover } from '../account/account-menu/NewAccountMenuPopover';
import { SecurityLevelsPopup } from '../security-levels-popup/SecurityLevelsPopup';
export const AccountMenuItem = ({ accountMenu, login, registration, isDesktop, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const dispatch = useDispatch();
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const { authUrl, isLoggedIn, postLogin, logout } = useOAuth();
    const isClient = useIsClient();
    const [open, setOpen] = useState(false);
    const toggleOpen = () => {
        setOpen(prev => !prev);
    };
    const handleSidebarClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        if (isClient && !isNewAuth) {
            dispatch(sessionActions.createInitAction());
        }
    }, [isClient, isNewAuth, dispatch]);
    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }
        postLogin();
    }, [isLoggedIn, postLogin]);
    const sharedMobileLinkProps = {
        icon: {
            title: 'user icon',
            source: isLoggedIn ? UserCheckIcon : UserIcon,
            size: 'xs',
            color: 'neutral',
            testId: 'account',
        },
        variant: 'plain',
        size: 'sm',
        testId: 'login-button',
    };
    const triggerContent = isDesktop ? (isNewAuth && !isLoggedIn ? (_jsxs(Link, { testId: "login-button", theme: "neutral", variant: "tertiary", size: "sm", href: authUrl, children: [_jsx(Icon, { source: UserIcon, size: "sm" }), t('account.login.title.login')] })) : (_jsxs(LinkButton, { testId: "login-button", theme: "neutral", variant: "tertiary", size: "sm", onClick: toggleOpen, children: [_jsx(Icon, { source: isLoggedIn ? UserCheckIcon : UserIcon, size: "sm" }), isLoggedIn ? t('account.account') : t('account.login.title.login')] }))) : isNewAuth && !isLoggedIn ? (_jsx(IconLink, Object.assign({ href: authUrl }, sharedMobileLinkProps))) : (_jsx(IconButton, Object.assign({}, sharedMobileLinkProps, { onClick: toggleOpen })));
    if (isLoggedIn) {
        return (_jsxs(_Fragment, { children: [_jsx(NewAccountMenuPopover, { items: accountMenu, logout: logout, triggered: open, onClose: handleSidebarClose, children: triggerContent }), _jsx(SecurityLevelsPopup, {})] }));
    }
    if (isNewAuth) {
        return triggerContent;
    }
    return (_jsx(NewAuthenticationContainer, { actionUri: login === null || login === void 0 ? void 0 : login.actionUri, onClose: handleSidebarClose, registrationLink: registration === null || registration === void 0 ? void 0 : registration.link, triggered: open, children: triggerContent }));
};
